export const DEFAULT_TEMPLATE = [[]];
